var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { omit, pick } from 'lodash';
import { useComponentProps } from '../context/component-props-context';
import { CellLabel } from '../elements/cell-label';
var cls = classNames('explorer-aside-section');
export var ExplorerAsideSectionDefaultProps = {
  colors: {
    background: 'app-chrome',
    text: 'subtle'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    ", ";\n    ", "\n  "], ["\n    padding: ", " ", " ", ";\n    ", ";\n    ", "\n  "])), theme.UNIT(3), theme.UNIT(4), theme.UNIT(5), theme.APPLY_COLORS, function (_a) {
    var colors = _a.colors;
    return colors.border && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-top: 1px solid ", ";\n    "], ["\n      border-top: 1px solid ", ";\n    "])), theme.COLOR(colors.border));
  }),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n  "], ["\n    padding: ", " ", " ", ";\n  "])), theme.UNIT(3), theme.UNIT(6), theme.UNIT(5))
});
var LabelStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n\n    \n  "], ["\n    ", ";\n\n    \n  "])), theme.APPLY_COLORS)
});
// -------- Components -------->
var My = {
  NAME: 'ExplorerAsideSection',
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled(CellLabel)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
export var ExplorerAsideSection = function (props) {
  var componentProps = useComponentProps(My.NAME, ExplorerAsideSectionDefaultProps, props);
  var className = componentProps.className,
    colors = componentProps.colors,
    label = componentProps.label,
    children = componentProps.children;
  var containerColors = omit(colors, 'text');
  var labelColors = pick(colors, 'text');
  return React.createElement(My.Container, {
    colors: containerColors,
    className: cls.name(className)
  }, label && React.createElement(My.Label, {
    colors: labelColors
  }, label), children);
};
ExplorerAsideSection.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;